import React from 'react';
import './ProofMetrics.css';

const ProofMetrics = ({ sessionStats, animatedValues, proofT }) => {
  return (
    <div className="metrics-section">
      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-value">
            {sessionStats.isLoading ? (
              <span style={{ opacity: 0.7, fontSize: '0.9em' }}>{proofT('metrics.loading')}</span>
            ) : (
              sessionStats.displayText
            )}
          </div>
          <div className="metric-label">{proofT('metrics.totalInteractions')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">{animatedValues.avgROI}%</div>
          <div className="metric-label">{proofT('metrics.averageROI')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">{animatedValues.costReduction}%</div>
          <div className="metric-label">{proofT('metrics.processCostSavings')}</div>
        </div>
        <div className="metric-card">
          <div className="metric-value">{animatedValues.responseTime.toFixed(1)}s</div>
          <div className="metric-label">{proofT('metrics.avgResponseTime')}</div>
        </div>
      </div>
    </div>
  );
};

export default ProofMetrics;






